import { render, staticRenderFns } from "./indexYiAn.vue?vue&type=template&id=80a34136&scoped=true&"
import script from "./indexYiAn.vue?vue&type=script&lang=js&"
export * from "./indexYiAn.vue?vue&type=script&lang=js&"
import style0 from "./indexYiAn.vue?vue&type=style&index=0&id=80a34136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a34136",
  null
  
)

export default component.exports